// eslint-disable-next-line @typescript-eslint/no-empty-object-type
export type IEmpty = {};
export const EMPTY: IEmpty = {};
